// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const planter = defineModel({
  id: "planter",
  batchId: "future",
  name: "Planter",
  tags: ["scenery","planter","low-poly","age-of-mcp","future"],
  summary: "A planter of greenery — portable street and courtyard decoration.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.18,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.07, 0.05, 0.05, 8), color: "#938a77", position: [0, 0.025, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.06, 0.06, 8), color: "#b6ab97", position: [0, 0.08, 0] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.06, 0.18, 10), color: "#b6ab97", position: [0, 0.2, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.02, 4, 10), color: "#938a77", position: [0, 0.29, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.03, 10), color: "#4a3526", position: [0, 0.29, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#4f8a3e", position: [0, 0.36, 0], scale: [1.2, 0.9, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#62a64c", position: [0.06, 0.44, 0.02] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#d8504a", position: [-0.08, 0.42, 0.06] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#e8c24a", position: [0.08, 0.4, -0.06] },
      { geometry: new THREE.SphereGeometry(0.025, 6, 5), color: "#d8504a", position: [0, 0.48, -0.04] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.BoxGeometry(0.28, 0.18, 0.16), color: "#b6ab97", position: [0, 0.09, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.03, 0.18), color: "#938a77", position: [0, 0.18, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.04, 0.12), color: "#4a3526", position: [0, 0.18, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#4f8a3e", position: [-0.07, 0.24, 0], scale: [1.2, 0.9, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#62a64c", position: [-0.01, 0.32, 0.02] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#d8504a", position: [-0.15, 0.3, 0.06] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#e8c24a", position: [0.01, 0.28, -0.06] },
      { geometry: new THREE.SphereGeometry(0.025, 6, 5), color: "#d8504a", position: [-0.07, 0.36, -0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#4f8a3e", position: [0.07, 0.24, 0], scale: [1.2, 0.9, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#62a64c", position: [0.13, 0.32, 0.02] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#d8504a", position: [-0.01, 0.3, 0.06] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5), color: "#e8c24a", position: [0.15, 0.28, -0.06] },
      { geometry: new THREE.SphereGeometry(0.025, 6, 5), color: "#d8504a", position: [0.07, 0.36, -0.04] },
    ] },
  ],
  animations: [],
});
